const customRules = {
  pageName: 'Custom Rules',
  btnCreate: 'Create',
  form: {
    header: {
      create: {
        title: 'Custom Rules',
      },
      update: {
        title: 'Custom Rules',
      },
    },
    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
          type: {
            name: 'Type',
            values: {
              tripPriority: 'Trip Priority',
              driverPriority: 'Driver Priority',
              passengerPreferences: 'Passenger Preferences',
            },
          },
          passengerRuleType: {
            name: 'Rule Type',
            options: {
              passengers: 'Passengers',
              drivers: 'Drivers',
              vehicles: 'Vehicles',
              passengersAndDrivers: 'Passenger & Drivers',
            },
          },
          source: {
            name: 'Source',
            values: {
              internal: 'Passenger Profiles',
              integration: 'Guest Bookings',
            },
          },
        },
      },
      preference: {
        header: 'Preferences',
        fields: {
          passenger: 'Passenger',
          passengers: 'Passengers',
          preferenceType: {
            name: 'Preference Type',
            values: {
              rideTogether: 'Ride Together',
              rideApart: 'Ride Apart',
              preferredDriver: 'Preferred Driver',
              excludedDriver: 'Excluded Driver',
              strictDriver: 'Strict Driver',
              preferredVehicle: 'Preferred Vehicle',
              excludedVehicle: 'Excluded Vehicle',
            },
          },
          drivers: 'Drivers',
          driverPreferenceType: {
            name: 'Preference Type',
          },
          vehicleBy: {
            name: 'Vehicle By',
            values: {
              makeAndModel: 'Vehicle Make / Model',
              name: 'Vehicle Name',
            },
          },
          vehicleMake: 'Vehicle Make',
          vehicleModels: 'Vehicle Models',
          vehicleNames: 'Vehicle Names',
          frequency: {
            name: 'Frequency',
            values: {
              always: 'Always',
              specificRange: 'Specific Range',
            },
          },
          dateFrom: 'Date From',
          dateTo: 'Date To',
          timeFrom: 'Time From',
          timeTo: 'Time To',
          weekdays: 'Weekdays',
          direction: {
            name: 'Direction',
            values: {
              both: 'From & To',
              pickup: 'From',
              dropoff: 'To',
            },
            warningNoLocation: 'If no location is selected, choosing “Direction: From/To” will automatically separate Leg A and Leg B.',
          },
          location: 'Location',
          pickupOrder: {
            name: 'Set Pickup Order',
          },
        },
        actions: {
          add: '+ Add Preference',
          addPassenger: 'Add',
        },
      },
      priority: {
        header: 'Record {{count}}',
        recordHeader: 'Record',
        scoreLabel: 'Score',
        fields: {
          attributes: 'Attributes',
          areas: 'Zones',
          profiles: 'Profiles',
        },
        btnAddPriority: {
          label: '+ Add Record',
          tooltip: 'Add a new record level',
        },
      },
    },
    footer: {
      btnSubmit: {
        create: 'Submit',
        submitAndCreate: 'Submit and Create',
        update: 'Submit',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Type',
      priority: 'Priority',
      record: 'Record',
      value: 'Value',
      score: 'Score',
      passengerRuleType: 'Rule Type',
    },
    filters: {
      recordType: 'Record',
    },
    actions: {
      delete: {
        header: 'Delete',
        modal: {
          header: 'Delete Custom Rules',
          body: 'You are about to delete {{num}} rules.',
        },
        toast: {
          success: 'Success!',
          error: 'Error!',
        },
      },
    },
    tabs: {
      tripsRules: 'Trips Rules',
      driversRules: 'Drivers Rules',
      passengersRules: 'Passengers Preferences',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    toastSuccess: 'Success!',
    toastError: 'Fail',
    toastValidationMessage: 'Please add attributes',
    errorConflict: {
      title: 'Passengers Rule Conflict',
      body: 'There is a conflict with the rule you are trying to create. These passengers are already assigned to another rule for the same specific time range.',
    },
  },
  edit: {
    toastSuccess: 'Success!',
    toastError: 'Fail',
    toastValidationMessage: 'Please add attributes',
    errorConflict: {
      title: 'Passengers Rule Conflict',
      body: 'There is a conflict with the rule you are trying to update. These passengers are already assigned to another rule for the same specific time range.',
    },
  },
};

export default customRules;
